import React, { useEffect, useState } from "react";

import "./../styles/styles.css";
import { SharpButtons } from "./SharpButtons";
import { Handler } from "../common/handler";
import { PlayButton } from "./PlayButton";
import SaveDialog from "./SaveDialog";
import DeleteDialog from "./DeleteDialog";
import wx from "weixin-js-sdk";
import { getUrlParam } from "../utils/helpers";

interface ViewerTopNavBarProps {
  title: string;
  handler: Handler | null;
}

function ViewerTopNavBar({
  title,
  handler,
}: ViewerTopNavBarProps) {

  return (
    <div className="top-nav-bar">
      <div className="left-buttons">
        <h3 className="new-title">{title}</h3>
        <PlayButton handler={handler} />
      </div>
    </div>
  );
}

export default ViewerTopNavBar;
